export default (params) => ({
  trigger: {
    name: 'promo_box.view_promobox',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
    },
    event: {
      name: 'view_content',
      params: {
        sub_feature: null,
      },
    },
    nonInt: true,
  },
});
